var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 3.90004V4.69016L11.7684 4.87292C13.5992 5.30824 14.7497 6.95801 14.7497 9.16671V13.3334V13.7476L15.0426 14.0405L15.8355 14.8334H5.66389L6.45678 14.0405L6.74967 13.7476V13.3334V9.16671C6.74967 6.94878 7.89238 5.30855 9.73022 4.8731L10.4997 4.69079V3.90004V3.08337H10.9997V3.90004Z",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a91b2da581e2241915ffe7f72a570818.svg";
export { ForwardRef as ReactComponent };